'use client';

import { useEffect } from 'react';

interface ScrollToSectionProps {
  paramKey?: string;
  behavior?: ScrollBehavior;
}

export const ScrollToSection = ({
  paramKey = 'section',
  behavior = 'auto',
}: ScrollToSectionProps) => {
  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    const fromQuery = sp.get(paramKey);

    const fromHash =
      !fromQuery && window.location.hash ? window.location.hash.slice(1) : null;

    const id = fromQuery ?? fromHash;
    if (!id) return;

    const el = document.getElementById(id);
    if (!el) return;

    const rafId = requestAnimationFrame(() => {
      el.scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior,
      });
    });

    return () => cancelAnimationFrame(rafId);
  }, [paramKey, behavior]);

  return null;
};
